// Heading rows in Ghost's flat secondary navigation start a new footer group.
export default function groupFooterNavigation() {
    document.querySelectorAll("[data-footer-secondary]").forEach((source) => {
        const items = Array.from(source.querySelectorAll(".nav > li"));
        const headingFor = (item) => item.querySelector("a")?.textContent.trim().match(/^#(heading|utility);\s*(.+)$/i);

        if (!items.some(headingFor)) {
            return;
        }

        const groups = document.createDocumentFragment();
        let list;
        const utilityTarget = source.closest("footer")?.querySelector("[data-footer-utility]");
        const startGroup = (label, utility = false) => {
            const group = document.createElement("div");
            const heading = document.createElement("h3");
            heading.textContent = label;
            const nav = document.createElement("nav");
            nav.className = "lds-footer-vnext__nav";
            nav.setAttribute("aria-label", label);
            list = document.createElement("ul");
            list.className = "nav";
            nav.append(list);
            if (utility && utilityTarget) {
                utilityTarget.append(nav);
            } else {
                group.append(heading, nav);
                groups.append(group);
            }
        };

        items.forEach((item) => {
            const heading = headingFor(item);
            if (heading) {
                startGroup(heading[2].trim(), heading[1].toLowerCase() === "utility");
            } else {
                if (!list) {
                    startGroup("More");
                }
                list.append(item);
            }
        });
        source.classList.add("lds-footer-vnext__secondary-groups");
        source.replaceChildren(groups);
    });
}
